var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "_badge",
      class: {
        _v: _vm.visible && ((_vm.value && _vm.dvalue) || _vm.$slots.default)
      },
      attrs: { inert: "" }
    },
    [_vm._t("default", [_vm._v(_vm._s(_vm.dvalue))])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }